import styled from "styled-components";
import { HashLink } from 'react-router-hash-link';

export const Container = styled.section`
    width: 100%;
    padding: 95px 0 40px;
    transition: 0.2s;
    @media screen and (max-width: 767px){
        padding: 95px 20px 40px;
    }
`
export const Wrap = styled.div`
    max-width: 1140px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
`


export const List = styled.ul`
    display: flex;
    align-items: stretch;
    transition: 0.2s;
    width: 100%;
    ${props => props.$customStyles || ''};
    @media screen and (max-width: 767px) {
        flex-direction: column;
        align-items: center;
        gap: 44px;
    }
`
export const ListItem = styled.li`
    padding: 22px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    width: calc(100% / 2);
    max-width: 324px;
    transition: 0.2s;
    @media screen and (max-width: 767px){
        width: 100%;
        padding: 0;
    }
`
export const ItemImg = styled.img`
    height: 80px;
`
export const ItemTitle = styled.h3`
    color: #00a0e7;
    font-size: 20px;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 0;
`
export const ItemText = styled.p`
    color: #666666;
    font-size: 17px;
    line-height: 1.66em;
    text-align: center;
`
export const ItemBtn = styled(HashLink)`
    margin-top: auto;
    padding: 20px 28px;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 2px;
    border: 2px #00a0e7 solid;
    text-decoration: none;
    font-weight: 700;
    color: #00a0e7;
    background: transparent;
    position: relative;
    overflow: hidden; 
    z-index: 1;
    transition: color 0.4s ease;
    &::before {
        content: '';
        position: absolute;
        background: #00a0e7;
        top: 50%;
        left: 50%;
        width: 200px;
        height: 200px;
        z-index: -1;
        transform-origin: center;
        transform: translate(-50%, -50%) rotate(-45deg) scaleX(0);
        transition: transform 0.4s ;
    }
    
    &:hover {
        color: #ffffff;
        &::before {
            transform: translate(-50%, -50%) rotate(-45deg) scaleX(1);
        }
    }
`;
